export default __webpack_public_path__ + "static/media/detail_big_5_2.05988c97.png";